import { Suspense, useEffect } from 'react'
import { renderRoutes } from 'react-router-config'
import { Redirect, useLocation } from 'react-router-dom'
import { useToken } from './utilities/hooks'
import { trackPageView } from './utilities/analytics'
import { TokenContextProvider } from './contexts/TokenContext'
import Frame from './Frame'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

function Routes({ routes }) {
  const { token, authorizedRoutes } = useToken()
  const location = useLocation()
  const currentPath = window.location.pathname

  useEffect(() => {
    trackPageView(location.pathname)
  }, [location.pathname])

  if (currentPath === '/') {
    const firstAuthorizedRoute = authorizedRoutes.find(
      route => route !== '/login'
    )
    if (firstAuthorizedRoute) {
      return <Redirect to={firstAuthorizedRoute} />
    }
  }
  if (token)
    return (
      <Frame>
        {/*
          Inner Suspense: scoped to the Frame content area so route transitions
          only spinner the page body while the sidebar/topbar remain mounted.
          The outer Suspense in App.jsx handles pre-auth routes. Keep both.
        */}
        <Suspense
          fallback={
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%'
              }}
            >
              <CircularProgress />
            </Box>
          }
        >
          {renderRoutes(
            routes.filter(route => authorizedRoutes.includes(route.path))
          )}
        </Suspense>
      </Frame>
    )
  return <Redirect to='/login' />
}

function Auth({ route }) {
  return (
    <TokenContextProvider>
      <Routes routes={route.routes} />
    </TokenContextProvider>
  )
}

export default Auth
